export class LoadQuickRequest {
  truckId: number;
  driverId: number;
  dispatcherId: number;
  rate: number;
}
